
import {neverland as $, render, html, useState} from 'neverland';

import App from './components/App.js';

render(document.body, html`
	${App()}
`);